import { Utils } from '@Util/utils'
import { ListViewMatchDetails } from '../list-view/list-view'
import { AddOnDetails } from '../ticket-form-summary/ticket-form-summary'
import { MatchStatus, NUMBER_SELECTION_SUMMARY } from './number-selection-summary-types'

import './styles.scss'

type NumberSelectionSummaryProps = {
  addOnDetails: AddOnDetails[]
  numbersPerRow: number
  numberSelections: ListViewMatchDetails[]
  type?: NUMBER_SELECTION_SUMMARY
  className?: string
}

const CLASS_NAME = `gby-k2g-number-selection-summary`

export const NumberSelectionSummary = (props: NumberSelectionSummaryProps) => {
  if (props.numbersPerRow < 1) {
    throw new Error(
      `Invalid Property: numbersPerRow = ${props.numbersPerRow} must be greater than 0`,
    )
  }
  const numRows = Math.ceil(props.numberSelections.length / props.numbersPerRow)
  const rows: JSX.Element[] = []
  for (let i = 0; i < numRows; i++) {
    const elements: JSX.Element[] = []
    for (
      let j = i * props.numbersPerRow;
      j < (i + 1) * props.numbersPerRow && j < props.numberSelections.length;
      j++
    ) {
      const selection = props.numberSelections[j]
      const colorOverride = props.addOnDetails
        .map((details) => {
          const matchStatus = props.numberSelections[j].matchStatus
          let newColor = details.color

          if (matchStatus === MatchStatus.UNMATCHED) {
            newColor = null
          } else if (matchStatus === MatchStatus.UNKNOWN) {
            newColor = `${details.color}40`
          }
          return {
            name: details.name,
            color: newColor,
          }
        })
        .find((details) => selection.addOnName === details.name)

      elements.push(
        <div
          key={`${CLASS_NAME}_selection_${j}`}
          className={`${CLASS_NAME}__number`}
          data-state={props.numberSelections[j].matchStatus}
          data-type={props.type || NUMBER_SELECTION_SUMMARY.BASE}
          style={
            colorOverride?.color
              ? {
                  backgroundColor: colorOverride.color,
                  borderColor: colorOverride.color,
                }
              : undefined
          }>
          {Utils.zeroPadNumber(props.numberSelections[j].number)}
        </div>,
      )
    }

    rows.push(
      <div
        key={`${CLASS_NAME}_row_${i}`}
        aria-label={'selected numbers'}
        className={`${CLASS_NAME}__number-row ${props.className}`}>
        {elements}
      </div>,
    )
  }
  return rows
}
